<div class="search-container">
  <div class="search-input-wrapper">
    <span class="search-icon">🔍</span>
    <input
      type="text"
      class="search-input"
      [placeholder]="'Søg i changelog...'"
      [value]="searchQuery"
      (input)="onSearch($event)"
    />
    @if (searchQuery) {
    <button
      class="clear-search-button"
      (click)="clearSearch()"
      aria-label="Ryd søgning"
    >
      ✕
    </button>
    }
  </div>
</div>
